import './PromotionalCoursesSection.less';
import React, {useState, useEffect} from 'react';
import Request from "../../../../bootstrap/api/Request";
import CourseListParcel from "../../../api/endpoints/course/CourseListParcel";
import Toasts, {TOAST_ERROR, TOAST_INFO} from "../../../../bootstrap/scomponents/toasts/Toasts";
import TitledSection from "../../../components/titled-section/TitledSection";
import __ from "../../../i18n";
import Spinner from "../../../../bootstrap/components/spinner/Spinner";
import CourseItemCard from "../../../widgets/course-item-card/CourseItemCard";
import GridView from "../../../components/grid-view/GridView";
import {GRID_VIEW_SIZE_SMALL} from "../../../view-constants/listing";


export default function PromotionalCoursesSection({promotionId}) {

    const [data, setData] = useState(null);

    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);

        const filters = [
            {field: 'promotion_id', operator: '=', value: promotionId}
        ];

        const filtersConfig = {
            promotion_id: {
                type: 'number'
            }
        };

        const orders = [
            {key: 'priority', isAsc: false},
            {key: 'id', isAsc: false}
        ];

        const limit = GRID_VIEW_SIZE_SMALL;

        const refNames = ['image', 'user', 'promotion'];

        Request.add(new CourseListParcel({filters, filtersConfig, orders, limit, refNames}))
            .then(data => {
                setData(data);
            })
            .catch(error => {
                Toasts.add(TOAST_ERROR, error.getMessage());
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return <div className="promotional-courses-section">
        <TitledSection title={__('Courses in this promotion')}>
            {
                isLoading &&
                <Spinner size={2}/>
            }
            {
                data !== null &&
                <GridView density="medium">
                    {
                        data.items.map(item => {
                            return <CourseItemCard
                                key={item.id}
                                course={item}
                                avatarImage={data.refs.images.find(t => t.id === item.avatar_image_id)}
                                creator={data.refs.users.find(t => t.id === item.creator_id)}
                                promotion={data.refs.promotions.find(t => t.id === item.promotion_id)}
                            />;
                        })
                    }
                </GridView>
            }
        </TitledSection>
    </div>;
}
